const StorageTypesSchema = ['localStorage', 'sessionStorage'] as const;

export type StorageType = (typeof StorageTypesSchema)[number];

export const defaultStorageType: StorageType = 'localStorage';
